import classNames from "classnames";
import React from "react";
import { actions } from "react-redux-form";
import _ from "underscore";

import { CheckBox, Errors, NumberStepper } from "../../../../core/atoms/rrf";
import { CommonProps, EnquiryFormSection, getTravellerCount } from "./common";
import { FormProgressIcon } from "./formProgressIcon";

import "./budgetPerPerson.scss";

interface OwnProps {
  currency: IBaseCurrency;
  dispatch: any;
}

export class BudgetPerPerson extends EnquiryFormSection<OwnProps> {
  protected shouldUpdateValidity(oldProps: CommonProps, newProps: CommonProps) {
    return !_.isEqual(oldProps.formState.budget, newProps.formState.budget);
  }

  protected syncValidity(formState: Forms.EnquiryForm) {
    if (!formState.budget) {
      return;
    }

    const { budgetPerPerson, budgetUnknown } = formState.budget;

    const fieldErrors = {
      budgetRequired: budgetUnknown !== true && (budgetPerPerson == null || budgetPerPerson < 1),
    };

    this.props.dispatch(actions.setErrors(this.props.model, fieldErrors));
  }

  public render() {
    const { model, className, id, formState, currency } = this.props;
    const budgetUnknown = formState?.budget?.budgetUnknown ?? null; // Initialise as null so spinner is enabled
    const budgetPerPerson = formState?.budget?.budgetPerPerson ?? null;
    const travellerCount = formState?.travellers ? getTravellerCount(formState.travellers) : 0;

    return (
      <section id={id} className={classNames("budget-per-person", className)}>
        <header>
          <FormProgressIcon model={model} />
          <h2>What&#39;s your budget per person?</h2>
          <p>This number should not include the price of international flights</p>
        </header>

        <div className="enquiry-form-question">
          <Errors model={model} messages={{ budgetRequired: `Please tell us your budget, or tick "I'm not sure"` }} />

          <div className="budget-per-person__stepper">
            <label htmlFor={`${model}.budgetPerPerson`}>Budget per person ({currency.name})</label>
            <NumberStepper
              model={`${model}.budgetPerPerson`}
              title="budget per person"
              disabled={budgetUnknown != null && budgetUnknown}
              min={0}
              step={250}
            />
          </div>

          {(travellerCount > 0 && budgetPerPerson > 0) &&
            <p>Total budget for your trip: <strong><small>{currency.symbol}</small> {travellerCount * budgetPerPerson}</strong></p>
          }

          <CheckBox
            id={"budget-per-person"}
            model={`${this.props.model}.budgetUnknown`}
            label="I'm not sure, please advise me"
            subLabel="Your local expert will build a great value itinerary tailor-made to your preferences"
          />
        </div>
      </section>
    );
  }
}
